;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();import React from 'react';

import PropTypes from 'prop-types';

import CarouselProvider from 'components/ui/CarouselProvider';

import { blockRootProps } from 'utils';

import CarouselShowcaseWithCard from './CarouselShowcaseWithCard';

const BlockCarouselShowcaseWithCard = ({
    __typename,
    anchorId,
    cardsPosition,
    slides,
    flushTop,
    flushBottom,
    navTheme,
}) => {
    cardsPosition ??= 'right';
    navTheme ??= 'blue';

    return (
        <div {...blockRootProps(anchorId, __typename)}>
            <CarouselProvider slides={slides}>
                <CarouselShowcaseWithCard
                    flushTop={flushTop}
                    flushBottom={flushBottom}
                    navTheme={navTheme}
                    cardsPosition={cardsPosition}
                />
            </CarouselProvider>
        </div>
    );
};

BlockCarouselShowcaseWithCard.propTypes = {
    __typename: PropTypes.string,
    anchorId: PropTypes.string,
    cardsPosition: PropTypes.oneOf(['left', 'right']),
    flushTop: PropTypes.bool,
    flushBottom: PropTypes.bool,
    navTheme: PropTypes.oneOf(['blue', 'white']),
    slides: PropTypes.array,
};

export default BlockCarouselShowcaseWithCard;
